export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/62c8fe91c0ea8c12bc270583fa2155fe.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center text-center px-4 md:px-8 max-w-5xl mx-auto">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-white/30 rounded-full px-4 py-1.5 mb-8 backdrop-blur-sm bg-white/5">
          <span className="w-2 h-2 flex items-center justify-center">
            <i className="ri-apple-fill text-white text-xs" />
          </span>
          <span className="text-white/80 text-xs font-medium tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
            iOS Platform Specialists
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight tracking-tight mb-6" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          Modern iOS Applications
          <br />
          <span className="text-white/70 font-light">For Enhanced Security</span>
        </h1>

        {/* Subheadline */}
        <p className="text-base md:text-xl text-white/70 font-light max-w-2xl leading-relaxed mb-12" style={{ fontFamily: "'Inter', sans-serif" }}>
          Expert team developing VPN and Cleaner solutions<br className="hidden md:block" />
          to elevate your mobile experience and protect your privacy.
        </p>

        {/* Scroll Indicator */}
        <button
          onClick={() => handleScroll('#about')}
          className="flex flex-col items-center gap-2 text-white/50 hover:text-white/80 transition-colors cursor-pointer group"
          aria-label="Scroll to About"
        >
          <span className="text-xs tracking-widest uppercase font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>Discover More</span>
          <div className="w-5 h-5 flex items-center justify-center animate-bounce">
            <i className="ri-arrow-down-line text-lg" />
          </div>
        </button>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
}
